// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about_title {
  height: 446px;
  background-color: #FCAF17;
  text-align: center;
  font-size: 64px;
  line-height: 70px;
  font-weight: 700;
  padding: 0px 7% 45px 7%;
  display: flex;
  align-items: center;
}
@media screen and (max-width: 768px) {
  .about_title {
    font-size: 44px;
    font-weight: 700;
    line-height: 66px;
    height: 356px;
  }
}
@media screen and (max-width: 535px) {
  .about_title {
    font-size: 42px;
    line-height: 50px;
  }
}
@media screen and (max-width: 415px) {
  .about_title {
    font-size: 36px;
    line-height: 43px;
  }
}
.about_text-box {
  padding: 2% 27% 1%;
  background-color: #F2F2F7;
}
@media screen and (max-width: 768px) {
  .about_text-box {
    padding: 4% 21% 9%;
  }
}
@media screen and (max-width: 414px) {
  .about_text-box {
    padding: 5% 7% 5%;
  }
}
.about_text-box p {
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
}
.about_text-box_desc {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}
@media screen and (max-width: 768px) {
  .about_text-box_desc {
    font-size: 14px;
    line-height: 21px;
  }
}
.about_text-box_bold {
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
  margin-right: 10px;
}
@media screen and (max-width: 768px) {
  .about_text-box_bold {
    font-size: 14px;
    line-height: 19.6px;
  }
}
.about .demirorenmedya-img {
  margin-top: -11%;
  position: relative;
  z-index: 1;
}
@media screen and (max-width: 1440px) {
  .about .demirorenmedya-img {
    margin-top: -9%;
  }
}
@media screen and (max-width: 1024px) {
  .about .demirorenmedya-img {
    margin-top: -11%;
  }
}
@media screen and (max-width: 855px) {
  .about .demirorenmedya-img {
    margin-top: -13%;
  }
}
@media screen and (max-width: 768px) {
  .about .demirorenmedya-img {
    margin-top: -9%;
  }
}
@media screen and (max-width: 690px) {
  .about .demirorenmedya-img {
    margin-top: -9%;
  }
}
@media screen and (max-width: 590px) {
  .about .demirorenmedya-img {
    margin-top: -10%;
  }
}
@media screen and (max-width: 530px) {
  .about .demirorenmedya-img {
    margin-top: -5%;
  }
}
@media screen and (max-width: 436px) {
  .about .demirorenmedya-img {
    margin-top: -12%;
  }
}
@media screen and (max-width: 414px) {
  .about .demirorenmedya-img {
    margin-top: -3%;
  }
}
@media screen and (max-width: 376px) {
  .about .demirorenmedya-img {
    margin-top: -5%;
  }
}
@media screen and (max-width: 360px) {
  .about .demirorenmedya-img {
    margin-top: -8%;
  }
}
@media screen and (max-width: 330px) {
  .about .demirorenmedya-img {
    margin-top: -14%;
  }
}
.about .title {
  font-size: 20px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: 0em;
  text-align: center;
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/styles/About.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AAAR;AAGQ;EAZJ;IAaQ,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,aAAA;EAAV;AACF;AACQ;EAlBJ;IAmBQ,eAAA;IACA,iBAAA;EAEV;AACF;AADQ;EAtBJ;IAuBQ,eAAA;IACA,iBAAA;EAIV;AACF;AAFI;EACI,kBAAA;EACA,yBAAA;AAIR;AAFQ;EAJJ;IAKQ,kBAAA;EAKV;AACF;AAJQ;EAPJ;IAQQ,iBAAA;EAOV;AACF;AANQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAQZ;AALQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAOZ;AANY;EAJJ;IAKQ,eAAA;IACA,iBAAA;EASd;AACF;AAPQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AASZ;AARY;EALJ;IAMQ,eAAA;IACA,mBAAA;EAWd;AACF;AARI;EACI,gBAAA;EACA,kBAAA;EACA,UAAA;AAUR;AATQ;EAJJ;IAKQ,eAAA;EAYV;AACF;AAXQ;EAPJ;IAQQ,gBAAA;EAcV;AACF;AAbQ;EAVJ;IAWQ,gBAAA;EAgBV;AACF;AAfQ;EAbJ;IAcQ,eAAA;EAkBV;AACF;AAjBQ;EAhBJ;IAiBQ,eAAA;EAoBV;AACF;AAnBQ;EAnBJ;IAoBQ,gBAAA;EAsBV;AACF;AArBQ;EAtBJ;IAuBQ,eAAA;EAwBV;AACF;AAvBQ;EAzBJ;IA0BQ,gBAAA;EA0BV;AACF;AAzBQ;EA5BJ;IA6BQ,eAAA;EA4BV;AACF;AA3BQ;EA/BJ;IAgCQ,eAAA;EA8BV;AACF;AA7BQ;EAlCJ;IAmCQ,eAAA;EAgCV;AACF;AA/BQ;EArCJ;IAsCQ,gBAAA;EAkCV;AACF;AAhCI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAkCR","sourcesContent":[".about {\n    &_title {\n        height: 446px;\n        background-color: #FCAF17;\n        text-align: center;\n        font-size: 64px;\n        line-height: 70px;\n        font-weight: 700;\n        padding: 0px 7% 45px 7%;\n        display: flex;\n        align-items: center;\n    \n        \n        @media screen and (max-width: 768px) {\n            font-size: 44px;\n            font-weight: 700;\n            line-height: 66px;\n            height: 356px;\n        }\n        @media screen and (max-width: 535px) {\n            font-size: 42px;\n            line-height: 50px;\n        }\n        @media screen and (max-width: 415px) {\n            font-size: 36px;\n            line-height: 43px;\n        }\n    }\n    &_text-box {\n        padding: 2% 27% 1%;\n        background-color: #F2F2F7;\n\n        @media screen and (max-width:768px) {\n            padding: 4% 21% 9%; \n        }\n        @media screen and (max-width: 414px) {\n            padding: 5% 7% 5%;\n        }\n        p {\n            font-size: 18px;\n            font-weight: 400;\n            line-height: 27px;\n        }\n\n        &_desc {\n            font-size: 16px;\n            font-weight: 400;\n            line-height: 24px;\n            @media screen and (max-width: 768px) {\n                font-size: 14px;\n                line-height: 21px;\n            }\n        }\n        &_bold {\n            font-size: 16px;\n            font-weight: 600;\n            line-height: 26px;\n            margin-right: 10px;\n            @media screen and (max-width: 768px) {\n                font-size: 14px;\n                line-height: 19.6px;\n            }\n        }\n    }\n    .demirorenmedya-img {\n        margin-top: -11%;\n        position: relative;\n        z-index: 1;\n        @media screen and (max-width: 1440px) {\n            margin-top: -9%;\n        }\n        @media screen and (max-width: 1024px) {\n            margin-top: -11%;\n        }\n        @media screen and (max-width: 855px) {\n            margin-top: -13%;\n        }\n        @media screen and (max-width: 768px) {\n            margin-top: -9%;\n        }\n        @media screen and (max-width: 690px) {\n            margin-top: -9%;\n        }\n        @media screen and (max-width: 590px) {\n            margin-top: -10%;\n        }\n        @media screen and (max-width: 530px) {\n            margin-top: -5%;\n        }\n        @media screen and (max-width: 436px) {\n            margin-top: -12%;\n        }\n        @media screen and (max-width: 414px) {\n            margin-top: -3%;\n        }\n        @media screen and (max-width: 376px) {\n            margin-top: -5%;\n        }\n        @media screen and (max-width: 360px) {\n            margin-top: -8%;\n        }\n        @media screen and (max-width: 330px) {\n            margin-top: -14%;\n        }\n    }\n    .title {\n        font-size: 20px;\n        font-weight: 600;\n        line-height: 40px;\n        letter-spacing: 0em;\n        text-align: center;\n        margin-bottom: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
